import { Injectable, inject } from "@angular/core";
import {Store} from "@ngrx/store";
import {Router, UrlTree} from "@angular/router";
import {Observable, withLatestFrom} from "rxjs";
import {map} from "rxjs/operators";
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";

@Injectable({
  providedIn: 'root'
})
export class TeamWelcomeGuard {
  private _store = inject(Store);
  private _router = inject(Router);


  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    return this._store.pipe(
      withLatestFrom(
        this._store.select(SharedLoginSelectors.selectToken),
        this._store.select(SharedLoginSelectors.selectTenant)
      ),
      map(([_, token, tenant]) => {
        if (token?.info?.isGuest && !!token?.refreshToken) {
          return true;
        } else if (!!token?.refreshToken && !!tenant) {
          return this._router.createUrlTree(['team/init']);
        } else {
          return this._router.createUrlTree(['team/login']);
        }
      })
    );
  }
}
